export const SET_INTELLISENSE_DATA = "@LOWCODE/SET_INTELLISENSE_DATA";
